export default {"src":"/komodo/_next/static/media/coindesk_logo.8104960f.svg","height":75,"width":396,"blurWidth":0,"blurHeight":0};